import { verifyForgotPasswordOtp } from '../../../data/repositories/authRepository.js';

export const verifyForgotOtp = (contactNumber, otp) => verifyForgotPasswordOtp(contactNumber, otp);
